import React from 'react';

import FractionInput from './FractionInput';


export default (props) => {
    const renderInput = (fieldKey) => {
        const fieldData = _.get(props.itemData, ['inputs', fieldKey]);
        return (
            <FractionInput
                component_data={props.component_data}
                is_preview={props.is_preview}
                answer={props.answer}
                existing_answer={props.existing_answer}
                onChange={props.onChange(fieldKey)}
                fieldData={fieldData}
                fieldKey={fieldKey}
                fractionKey={props.fractionKey}
            />
        );
    }

    return (
        <div className="cc-fraction-fractionpart" style={props.itemData.style}>
            <div className="flex-row flex-v-center">
                {renderInput("v")}
            </div>
        </div>
    );
}